export const it = {
  "month": {
    "1": "Gennaio",
    "2": "Febbraio",
    "3": "Marzo",
    "4": "Aprile",
    "5": "Maggio",
    "6": "Giugno",
    "7": "Luglio",
    "8": "Agosto",
    "9": "Settembre", 
    "10": "Ottobre",
    "11": "Novembre",
    "12": "Dicembre"
  },
  "welcome": "Benvenuto",
  "navigation": {
    "dashboard": "Panoramica",
    "home": "Home",
    "standings": "Classifiche",
    "about": "Chi Siamo",
    "info": "Info",
    "login": "Accedi",
    "register": "Registrati",
    "profile": "Profilo",
    "settings": "Impostazioni",
    "actions": "Azioni",
    "language": "Lingua",
    "createYourOwnCompetition": "Crea il tuo Torneo!"
  },

  "app": {
    "welcomeMessage": "Crea e gestisti competizioni personalizzate di ogni genere: tornei a eliminazione diretta, gironi con playoff, girone unico, campionati stile F1 e chi più ne ha più ne metta!",
    "dashboardDescription": "Gestisci i tuoi tornei"
  },
  "common": {
    "country": "Nazione",
    "delete": "Elimina",
    "loading": "Caricamento...",
    "error": "Errore",
    "save": "Salva",
    "cancel": "Annulla",
    "email": "Email",
    "password": "Password",
    "required": "Campo richiesto",
    "name": "Nome",
    "confirmPassword": "Conferma Password",
    "login": "Accedi",
    "register": "Registrati",
    "logout": "Esci",
    "of": "di",
    "otherwise": "oppure",
    "remove": "Rimuovi",
    "close": "Chiudi",
    "saveSettings": "Salva Impostazioni",
    "backToTournament": "Torna al torneo",
    "confirm": "Conferma",
    "editing": "Modifica in corso",
    "edit": "Modifica",
  },
    "entryFlags": {
      "dnf": "DNF",
      "pole": "Pole position"
    },
  "auth": {
    "login": {
      "title": "Accedi",
      "subtitle": "Accedi al tuo account",
      "emailLabel": "Indirizzo Email",
      "passwordLabel": "Password",
      "loginButton": "Accedi",
      "noAccount": "Non hai un account?",
      "registerLink": "Registrati qui",
      "forgotPassword": "Password dimenticata?",
      "loginSuccess": "Login effettuato correttamente! Bentornato.",
      "loginError": "Credenziali non valide. Riprova.",
      "resetPassword": "Reimposta la password"
    },
    "register": {
      "title": "Registrati",
      "subtitle": "Crea il tuo account",
      "nameLabel": "Nome",
      "emailLabel": "Indirizzo Email",
      "passwordLabel": "Password",
      "confirmPasswordLabel": "Conferma Password",
      "registerButton": "Crea Account",
      "hasAccount": "Hai già un account?",
      "loginLink": "Accedi qui",
      "registerSuccess": "Registrazione completata!",
      "registerError": "Registrazione fallita. Controlla i tuoi dati.",
      "passwordMismatch": "Le password non coincidono"
    },
    "validation": {
      "emailRequired": "Email richiesta",
      "emailInvalid": "Inserisci un'email valida",
      "passwordRequired": "Password richiesta",
      "passwordMinLength": "La password deve essere di almeno 8 caratteri",
      "nameRequired": "Nome richiesto",
      "confirmPasswordRequired": "Conferma la tua password"
    }
    ,
    "reset": {
      "title": "Reset Password",
      "subtitle": "Inserisci la tua email per ricevere il link di reset",
      "emailLabel": "Indirizzo Email",
      "sendButton": "Invia link di reset",
      "sentSuccess": "Se quell'email è presente nel sistema, è stato inviato un link di reset.",
      "sendError": "Impossibile inviare il link. Riprova più tardi.",
      "backToLogin": "Torna al login"
    },
    "reset_confirm": {
      "title": "Imposta una nuova password",
      "subtitle": "Inserisci una nuova password per il tuo account",
      "passwordLabel": "Nuova Password",
      "confirmPasswordLabel": "Conferma Password",
      "resetButton": "Reimposta Password",
      "success": "La password è stata reimpostata correttamente. Ora puoi effettuare il login.",
      "error": "Impossibile reimpostare la password. Il token potrebbe essere scaduto o non valido."
    }
  },
  "button": {
    "register": "Registrati",
    "addEntryToGroup": "Aggiungi partecipante al Gruppo",
    "addEntry": "Aggiungi partecipante",
    "addNewParticipantToTournament": "Aggiungi un nuovo partecipante al torneo",
    "cancel": "Annulla",
    "addRound": "Aggiungi turno",
    "addNewTeamToTournament": "Aggiungi una nuova squadra al torneo",
    "ok": "OK",
    "createNewSeason": "Crea nuova stagione",
  },
  "messages": {
    "success": {
      "loginSuccess": "Login effettuato correttamente! Bentornato.",
      "registerSuccess": "Registrazione completata!"
    },
    "error": {
      "betPlacement": "Errore nel piazzare la scommessa",
      "eventStarted": "L'evento è già iniziato, non è possibile piazzare scommesse",
      "eventFinished": "L'evento è già terminato",
      "betExists": "Hai già una scommessa attiva su questo evento",
      "notFound": "Non trovato",
      "betDataInvalid": "Dati di scommessa non validi",
      "betRetrieveError": "Errore nel recupero della scommessa",
      "loadingBetsError": "Errore nel caricamento delle scommesse",
      "loginError": "Credenziali non valide. Riprova.",
      "registerError": "Registrazione fallita. Controlla i tuoi dati."
    }
  },
  "message": {
    "tournamentSettingsSaved": "Impostazioni del torneo salvate correttamente",
    "errorSavingTournamentSettings": "Errore durante il salvataggio delle impostazioni del torneo",
    "dataSaved": "Dati salvati correttamente",
    "errorSavingData": "Errore durante il salvataggio dei dati",
    "standingsColumnsRequired": "Seleziona almeno una colonna per la classifica",
    "standingsSortingFieldsRequired": "Seleziona almeno un criterio di ordinamento per la classifica",
    "addRoundsNoEntries": "Devi prima aggiungere partecipanti al gruppo",
    "recalculateStandingsInfo": "Ricalcola la classifica sulla base dei risultati dei turni completati.",
    "standingsRecalculatedSuccess": "Classifica ricalcolata correttamente.",
    "newSeasonCreatedSuccess": "Nuova stagione creata correttamente.",
    "newSeasonCreatedError": "Errore durante la creazione della nuova stagione. Riprova.",
    "tournamentNotRunning": "Il torneo non è in stato \"In corso\"",
    "noRunningSeason": "Nessuna stagione aperta trovata.",
    "youCantCloseSeason_reason": "Non puoi chiudere la stagione ora. Motivo: {reason}",
    "cantDoAction_reason": "Non puoi eseguire questa azione adesso. Motivo: {reason}",
  },
  "alerts": {
    "verifyEmail": "Verifica il tuo indirizzo email per sbloccare tutte le funzionalità del gioco!",
    "verifyEmailSent": "Abbiamo inviato un'email di verifica al tuo indirizzo. Controlla la posta!",
    "verifyEmailError": "Si è verificato un errore durante l'invio dell'email di verifica. Riprova più tardi."
  },
  "actions": {
    "verifyEmail": "Verifica email"
  },
  "tournament_action": {
    "recalculate_all_standings": "Ricalcola tutte le classifiche",
    "recalculate_all_standings_description": "Ricalcola le classifiche per tutti i gironi e le fasi basandosi sui risultati dei turni completati.",
    "recalculate_all_standings_button": "Ricalcola",
    "award_prizes": "Assegna premi",
    "award_prizes_description": "Assegna i premi ai vincitori secondo le regole del torneo.",
    "award_prizes_button": "Assegna",
    "create_new_season": "Crea una nuova stagione",
    "create_new_season_description": "Crea una nuova stagione preservando partecipanti e impostazioni di base dal torneo corrente.",
    "create_new_season_button": "Crea stagione",
    "close_season": "Chiudi la stagione",
    "close_season_description": "Chiudi la stagione in corso e assegna i premi ai vincitori.",
    "close_season_description_full": "Chiudi la stagione in corso, assegna i premi ai vincitori e crea una nuova stagione. Potrebbe metterci un po'.",
    "close_season_button": "Chiudi stagione",
    
  },
  "dashboard": {
    "totalBets": "Scommesse Totali",
    "totalWinnings": "Vincite Totali",
    "totalLost": "Soldi Persi Totali",
    "activePlayers": "Giocatori Attivi",
    "topPlayersTotal": "Migliori Giocatori",
    "topPlayersMonth": "Migliori del Mese",
    "recentActivity": "Attività Recente",
    "win": "Vincita",
    "winOfTheMonth": "Vincita del mese",
    "winOfTheWeek": "Vincita della settimana",
    "noDataAvailable": "Nessun dato disponibile",
    "noRecentActivity": "Nessuna attività recente",
    "viewFullStandings": "Classifica completa"
  },
  "action": {
    "bet": "Scommessa",
    "win": "Vincita",
    "lost": "Perdita"
  },
  "info": {
  "title": "Informazioni",
  "joinDiscord": "Unisciti a Discord",
    "subtitle": "Regole e funzionamento delle scommesse virtuali",
    "box1_title": "Crea Qualsiasi Competizione",
    "box1_description": "Tornei a eliminazione diretta, gironi all'italiana, sistema svizzero o FFA: scegli il formato e personalizza ogni dettaglio. Perfetto per sport, eSport e giochi di ogni tipo.",
    "box2_title": "Massima Flessibilità, Zero Limiti",
    "box2_description": "Combina formati e regole per costruire competizioni su misura. Dalle leghe stagionali ai tornei lampo: struttura, punteggi e avanzamenti li decidi tu.",
    "box3_title": "Gestione Semplice e Professionale",
    "box3_description": "Organizza partecipanti, calendari, classifiche e risultati in modo intuitivo. Tutto sotto controllo, dall'iscrizione alla proclamazione del vincitore."
  },
  "about": {
    "title": "Chi Siamo",
    "subtitle": "Scommesse virtuali su eventi sportivi reali per puro divertimento",
    "mission": {
      "title": "La Nostra Missione",
      "description": "Offrire un'esperienza di scommesse divertente e senza rischi su eventi sportivi reali, dove puoi testare le tue abilità predittive con soldi completamente virtuali."
    },
    "team": {
      "title": "Il Nostro Team",
      "description": "Azzibbo Dev"
    },
    "contact": {
      "title": "Community",
      "description": "Domande o suggerimenti?",
      "email": "Inviaci un'email",
      "discord": "Discord"
    },
    "version": "Versione"
  },
  "standings": {
  "title": "Classifica",
  "subtitle": "Classifiche e statistiche della community",
  "topPlayers-month": "Migliori del mese",
  "topPlayers-overall": "Migliori giocatori",
  "topPlayersOfMonth": "Migliori di {month}",
  "position": "Posizione",
  "player": "Giocatore",
  "winnings": "Vincita",
  "wonBets": "Vinte",
  "totalBets": "Scommesse",
  "futureTimeframe": "Mese nel futuro",
  "futureTimeframeDescription": "Le classifiche per questo mese non sono ancora disponibili. Torna quando il mese sarà iniziato!",
  "pastTimeframe": "Mese non disponibile",
  "pastTimeframeDescription": "Le classifiche per questo mese non sono disponibili. Il gioco è iniziato più tardi!",
  "goToCurrentMonth": "Vai al mese corrente"
  },
  "profile": {
    "title": "Profilo",
    "subtitle": "Gestisci il tuo account e le impostazioni",
    "userInfo": {
      "title": "Informazioni Utente",
      "welcome": "Benvenuto nel tuo profilo!",
      "username": "Nome utente",
      "email": "Indirizzo email"
    },
    "quickActions": {
      "title": "Azioni Rapide",
      "goToSettings": "Vai alle Impostazioni"
    }
  },
  "settings": {
    "title": "Impostazioni",
    "subtitle": "Personalizza la tua esperienza di gioco",
    "loading": "Caricamento impostazioni...",
    "saveChanges": "Salva Modifiche",
    "language": {
      "title": "Lingua",
      "subtitle": "Scegli la tua lingua preferita",
      "select": "Seleziona Lingua"
    },
    "notifications": {
      "title": "Notifiche",
      "subtitle": "Gestisci le tue preferenze di notifica",
      "results": "Notifiche sui risultati delle scommesse",
      "resultsTooltip": "Ricevi notifiche quando le tue scommesse vengono risolte",
      "updates": "Notifiche su aggiornamenti e news",
      "updatesTooltip": "Ricevi notifiche su aggiornamenti del gioco e novità",
      "verifyEmail": "Verifica il tuo indirizzo email per ricevere le notifiche."
    },
    "tips": {
      "title": "Consigli",
      "notification1": "Non riceverai spam, non condividiamo i tuoi dati con nessuno!"
    }
  },
  "privacy": {
    "title": "Privacy",
    "subtitle": "Informazioni sulla privacy e sui dati",
    "privacyAndCookies": "Privacy e Cookie",
    "content": {
      "title": "Politica sulla Privacy",
      "dataUsage": "I pochi dati che raccogliamo, cioè nome utente ed email, sono usati solo per cose che riguardano il gioco.",
      "noCookies": "Non ci sono cookie né script esterni."
    },
    "assurance": {
      "title": "La Tua Privacy è Protetta",
      "description": "Raccogliamo solo i dati essenziali per il funzionamento del gioco e non li condividiamo mai con terze parti.",
      "badge": "Nessun Tracking"
    }
  },
  "notFound": {
    "title": "Pagina non trovata",
    "subtitle": "La pagina che stai cercando non esiste o potrebbe essere stata rimossa.",
    "backHome": "Torna alla home"
  },
  "filterNotFound": {
    "season": "Stagione {value} non trovata.",
    "level": "Livello {value} non trovato.",
    "stage": "Fase {value} non trovata.",
    "group": "Gruppo {value} non trovato."
  },
  "tournaments": {
    "slug": "Alias URL",
    "teamStandings": "Classifica squadre",
    "createNew": "Crea Nuovo Torneo",
    "entries": "Partecipanti",
    "newTournament": "Nuovo Torneo",
    "tournamentName": "Nome Torneo",
    "description": "Descrizione",
    "createdSuccess": "Torneo creato con successo!",
    "createdError": "Errore nella creazione del torneo. Riprova.",
    "differentTypeForNextStages": "Potrai scegliere un tipo di competizione diverso per le fasi successive, ad esempio un girone all'italiana seguito da eliminazione diretta",
    "create": "Crea",
    "cancel": "Annulla",
    "startFromTemplate": "Parti da un Modello",
    "startFromTemplateDesc": "Parti da un modello predefinito, tipo F1, campionato di calcio, torneo a eliminazione diretta",
    "customTournament": "Campionato Custom",
    "customTournamentDesc": "Crea un torneo completamente personalizzato da zero",
    "next": "Avanti",
    "back": "Indietro",
    "saveDraft": "Salva Bozza",
    "step1Title": "Tipo di Competizione",
    "step2Title": "Format",
    "basic_info": "Informazioni Base",
    "competitionType": "Tipo di Competizione",
    "stagesSetup": "Configurazione Fasi",
    "stage_n": "Fase {n}",
    "addStage": "Aggiungi altre fasi",
    "singleStage": "Fase Singola",
    "multipleStages": "Torneo in più Fasi",
    "singleStageDesc": "C'è una sola fase del torneo, chi vince questa vince il torneo. Ad esempio un torneo knockout tipo coppa nazionale di calcio, o il campionato di F1",
    "multipleStagesDesc": "I vincitori di una fase passano alla fase successiva. Ad esempio la coppa del mondo di calcio che ha la fase a gironi e poi la fase knockout",
    "numberOfStages": "Numero di Fasi",
    "numberOfParticipants": "Numero di Partecipanti",    "participantsMinimum": "Deve essere maggiore di 1",    "participantsExceedPrevious": "Non pu\u00f2 superare il numero di partecipanti della fase precedente",
    "expectedParticipants": "Partecipanti Previsti",
    "numberOfGroups": "Numero di Gruppi",
    "qualificationRules": "Regole di Qualificazione",
    "qualifiedPerGroup": "Qualificati per Gruppo",
    "qualifiedPerGroupHint": "Numero di squadre/giocatori che passano alla fase successiva da ogni gruppo",
    "addEntryToGroup": "Aggiungi partecipante al Gruppo",
    "selectEntry": "Seleziona partecipante",
    "addNewParticipant": "Aggiungi Nuovo Partecipante",
    "addNewTeam": "Aggiungi Nuova Squadra",
    "entryCreatedSuccess": "Partecipante creato correttamente",
    "teamCreatedSuccess": "Squadra creata correttamente",
    "entryCreatedError": "Errore durante la creazione del partecipante. Riprova.",
    "roundsAddedSuccess": "Turni aggiunti correttamente",
    "entryUpdatedSuccess": "Partecipante aggiornato correttamente",
    "teamUpdatedSuccess": "Squadra aggiornata correttamente",
    "editParticipant": "Modifica Partecipante",
    "editTeam": "Modifica Squadra",
    "deleteEntry": "Elimina partecipante",
    "deleteEntryConfirm": "Sei sicuro di voler eliminare questo partecipante?",
    "deleteTeam": "Elimina squadra",
    "deleteTeamConfirm": "Sei sicuro di voler eliminare questa squadra?",
    "deleteRound": "Elimina turno",
    "deleteRoundConfirm": "Sei sicuro di voler eliminare questo turno?",
    "roundDeletedSuccess": "Turno eliminato correttamente",
    "roundDeletedError": "Errore durante l'eliminazione del turno. Riprova.",
    "entryDeletedSuccess": "Partecipante eliminato correttamente",
    "teamDeletedSuccess": "Squadra eliminata correttamente",
    "entryDeletedError": "Errore durante l'eliminazione del partecipante. Riprova.",
    "noParticipantsTitle": "Nessun partecipante trovato",
    "noParticipantsMessage": "Aggiungi partecipanti al torneo per poterli selezionare qui.",
    "noGroupParticipantsMessage": "Aggiungi partecipanti al gruppo per poterli selezionare qui.",
    "yourTournaments": "I Tuoi Tornei",
    "noTournaments": "Non hai ancora creato alcun torneo. Crea il tuo primo torneo ora!",
    "noRounds": "Nessun turno programmato",
    "upcomingRound": "Prossimo turno",
    "viewDetails": "Visualizza dettagli",
    "showTeamStandings": "Mostra classifica squadre",
    "showMainStandings": "Mostra classifica principale",
    "removeFromGroup": "Rimuovi dal gruppo",
    "removeFromGame": "Rimuovi dal match",
    "removeFromGroupConfirm": "Sei sicuro di voler rimuovere questo partecipante dal gruppo?",
    "removeFromGameConfirm": "Sei sicuro di voler rimuovere questo partecipante dal match?",
  },

  "competitionTypes": {
    "knockout": "Eliminazione Diretta",
    "round_robin": "Girone all'Italiana",
    "ffa": "Tutti contro tutti",
    "swiss": "Sistema Svizzero"
  },
  "competitionTypesDesc": {
    "knockout": "Torneo a eliminazione diretta dove chi perde viene eliminato",
    "round_robin": "Ogni squadra gioca contro tutte le altre una volta",
    "ffa": "Tutti i partecipanti competono contemporaneamente, vince chi ottiene il punteggio migliore"
  },
  
  "tournamentStates": {
    "draft": "Bozza",
    "open": "Aperto",
    "running": "In corso",
    "completed": "Completato",
    "archived": "Archiviato",
    "cancelled": "Annullato"
  },

  "roundStates": {
    "scheduled": "Programmato",
    "running": "In corso",
    "completed": "Completato",
    "cancelled": "Annullato"
  },
  "label": {
    "format": "Format",
    "started_on_date": "Iniziato il {date}",
    "enableTeams": "Attiva la gestione delle squadre",
    "manage_teams": "Gestisci squadre",
    "entry_number": "N.",
    "team": "Squadra",
    "tournamentType": "Tipo di Torneo",
    "type": "Tipo",
    "participants": "Partecipanti",
    "dashboard": "Dashboard",
    "examples": "Esempi",
    "standings": "Classifica",
    "fixtures": "Calendario",
    "selectParticipant": "Seleziona partecipante",
    "manage_entries": "Gestisci partecipanti",
    "state": "Stato",
    "standingsColumns": "Colonne Classifica",
    "standingsColumnsDescription": "Seleziona e ordina le colonne da visualizzare nelle classifiche",
    "standingsSortingFields": "Ordinamento Classifica",
    "standingsSortingFieldsDescription": "Scegli come ordinare le classifiche. Seleziona i campi e l'ordine.",
    "name": "Nome",
    "description": "Descrizione",
    "tournamentSettings": "Impostazioni del Torneo",
    "options": "Opzioni",
    "showFlags": "Mostra bandiere",
    "mainColor": "Colore principale",
    "add_N_rounds": "Aggiungi {n} turni",
    "round_n": "Turno {n}",
    "editRound": "Modifica turno",
    "group_n": "Gruppo {n}",
    "entry": "Partecipante",
    "season": "Stagione",
    "season_n": "Stagione {n}",
    "level": "Divisione",
    "level_n": "Divisione {n}",
    "group": "Gruppo",
    "notes": "Note"
    ,"competition": "Competizione"
    ,"manage": "Gestisci"
    ,"recalculateStandings": "Ricalcola classifica",
    "tournament_info": "Info torneo",
    "sortAutomaticallyAfterSaving": "Riordina dopo il salvataggio",
    "stage": "Fase",
    "stage_n": "Fase {n}",
    "createNewSeason": "Crea nuova stagione",
    "createNewSeason_n": "Crea stagione {n}",
    "close_season_n": "Chiudi stagione {n}"
  },
  "round": {
    "viewResults": "Risultati"
  },
  "standingsColumns": {
    "name": "Nome",
    "points": "Punti",
    "played": "Giocate",
    "wins": "Vittorie",
    "draws": "Pareggi",
    "losses": "Sconfitte",
    "score_for": "Gol Fatti",
    "score_against": "Gol Subiti",
    "score_difference": "Differenza Reti",
    "podiums": "Podio",
    "dnf": "DNF"
  },
  "sortingType": {
    "asc": "Crescente",
    "desc": "Decrescente"
  },

  "help": {
    "tournament_entries_title": "Partecipanti al torneo",
    "tournament_entries_description": "In questa sezione puoi gestire i partecipanti al torneo. Dopo dovrai aggiungerli ai gruppi per vederli e utilizzarli nelle classifiche e negli eventi. In questa sezione ci sono tutti i partecipanti associati al torneo, anche quelli ritirati o quelli che devono ancora essere assegnati a un gruppo.",
    "tournament_teams_title": "Squadre del torneo",
    "tournament_teams_description": "I partecipanti al torneo possono essere raggruppati in squadre. Serve soprattutto per Tornei FFA, tipo Formula 1 o ciclismo. Le \"squadre\" di calcio sono partecipanti, non vanno inserite qui."
  },

  "hof": {
    "rewardsInfo": "I premi possono essere assegnati automaticamente al termine di una stagione.\nDa qui puoi comunque aggiungere o rimuovere un premio manualmente.",
    "addRewardToEntry": "Assegna premio a un Partecipante",
    "addRewardToTeam": "Assegna premio a una Squadra",
    "awardType": "Tipo di Premio"
  },

  "award_types": {
    "winner": "Vincitore",
    "runner_up": "Secondo classificato",
    "third_place": "Terzo classificato"
  }

}
